import { VariableType } from 'json-to-graphql-query';

import { Resource } from './resource';

/**
 * Resource MDOK
 *
 * @export
 * @class MdokResource
 * @extends {Resource}
 */
export class MdokResource extends Resource {
  /**
   * Pobiera nazwę dokumentu z MDOK
   *
   * @param {*} variables
   * @returns {Promise<string>}
   * @memberof MdokResource
   */
  public getDocumentName(variables: any): Promise<string> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokDocumentName: { __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') } }
      }
    });
    return this.query({ query, variables }, 'mdokDocumentName');
  }

  /**
   * Pobiera nazwę dokumentu i datę dostarczenia z MDOK
   *
   * @param {*} variables
   * @returns {Promise<{ name: string; date?: Date }>}
   * @memberof MdokResource
   */
  public getDocumentNameAndIncomeDate(variables: any): Promise<{ name: string; date?: Date }> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokDocumentNameAndIncomeDate: {
          __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') }
        }
      }
    });
    return this.query({ query, variables }, 'mdokDocumentNameAndIncomeDate');
  }

  /**
   * Pobiera nazwę dokumentu i dane z MDOK
   *
   * @param {*} variables
   * @returns {Promise<{ name: string; data?: any  }>}
   * @memberof MdokResource
   */
  public getDocumentNameAndData(variables: any): Promise<{ name: string; data?: any }> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokDocumentNameAndData: {
          __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') }
        }
      }
    });
    return this.query({ query, variables }, 'mdokDocumentNameAndData');
  }

  /**
   * Pobiera nazwę sprawy z MDOK
   *
   * @param {*} variables
   * @returns {Promise<string>}
   * @memberof MdokResource
   */
  public getCaseName(variables: any): Promise<string> {
    const query = this.prepareOptions({
      query: {
        __variables: { uid: 'Int!', documentId: 'Int' },
        mdokCaseName: { __args: { uid: new VariableType('uid'), documentId: new VariableType('documentId') } }
      }
    });
    return this.query({ query, variables }, 'mdokCaseName');
  }
}

export const mdokResource = new MdokResource();
